import React from 'react';
import { Box, Typography, Autocomplete, TextField } from '@mui/material';
import ValidationErrorText from '../common/ValidationErrorText';

const percentageOptions = [
  '40%', '45%', '50%', '55%', '60%',
  '65%', '70%', '75%', '80%', '85%',
  '90%', '95%', '100%',
];

const cgpaOptions = [
  '4.0 / 10', '5.0 / 10', '5.5 / 10', '6.0 / 10',
  '6.5 / 10', '7.0 / 10', '7.5 / 10', '8.0 / 10',
  '8.5 / 10', '9.0 / 10', '9.5 / 10', '10 / 10',
];

const MinimumPercentageCGPA = ({
  label = 'Minimum Percentage / CGPA',
  value = { type: '', value: '' },
  onChange = () => {},
  readOnly = false,
  fieldError,
  fieldErrors,
  fieldType,
}) => {
  const selectedType = value?.type || '';
  const selectedValue = value?.value || '';

  const getOptions = () => {
    if (selectedType === 'Percentage') return percentageOptions;
    if (selectedType === 'CGPA') return cgpaOptions;
    return [];
  };

  const handleTypeChange = (_e, newType) => {
    onChange({ type: newType || '', value: '' });
  };

  const handleValueChange = (_e, newVal) => {
    onChange({ type: selectedType || '', value: newVal || '' });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography fontSize="14px" fontWeight="600" mb={1}>
        {label}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          alignItems: 'center',
          maxWidth: 520,
        }}
      >
        {/* Type Select */}
        <Box sx={{ minWidth: 220 }}>
          <Autocomplete
            options={['Percentage', 'CGPA']}
            value={selectedType || null}
            onChange={handleTypeChange}
            disabled={readOnly}
            clearOnBlur
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Percentage / CGPA"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  sx: { height: 38, fontSize: 13 },
                }}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: 13 },
                }}
              />
            )}
          />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}.type`]}/>
          
        </Box>

        {/* Value Select */}
        {selectedType && (
          <Box sx={{ minWidth: 220 }}>
            <Typography fontSize="13px" fontWeight={500} mb={0.5}>
              {selectedType === 'Percentage' ? 'Select Percentage' : 'Select CGPA'}
            </Typography>
            <Autocomplete
              options={getOptions()}
              value={selectedValue || null}
              onChange={handleValueChange}
              disabled={readOnly}
              clearOnBlur
              size="small"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={`Select ${selectedType}`}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: { height: 38, fontSize: 13 },
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: 13 },
                  }}
                />
              )}
            />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}.value`]}/>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MinimumPercentageCGPA;
